import axios from "axios";
import jwt_decode from 'jwt-decode';
import crypto from 'crypto';

const API_URL = "https://sotira-back-test.herokuapp.com/";
//const API_URL = "http://localhost:8080/";
const GOOGLE_LOGIN_HASH_KEY = "HASHKEY";

class AuthService {
  login(email: string, password: string, option: number) {
    return axios
      .post(API_URL + "login", {
        email,
        password
      })
      .then(response => {
        if (response.data.token) {
          if (option === 1) {
            localStorage.setItem("token", JSON.stringify(response.data.token));
          } else if (option === 0) {
            sessionStorage.setItem("token", JSON.stringify(response.data.token));
          } else {
            sessionStorage.setItem("token", JSON.stringify(response.data.token));
          }
        }
        return response.data;

      }).catch(function (error) {
        alert(error.response.data.errors);
        throw email
      });
  }

  loginGoogle(email: string, googleId: string, firstName: string, lastName: string, option:number) {
    const log_token = crypto.createHash('sha256').update(GOOGLE_LOGIN_HASH_KEY + googleId + email + firstName).digest('hex');
    return axios
      .post(API_URL + "login/google_login", {
        email,
        googleId,
        firstName,
        lastName,
        log_token
      })
      .then(response => {
        if (response.data.token) {
          //console.log("token make");
          if (option === 1) {
            localStorage.setItem("token", JSON.stringify(response.data.token));
          } else if (option === 0) {
            sessionStorage.setItem("token", JSON.stringify(response.data.token));
          } else {
            sessionStorage.setItem("token", JSON.stringify(response.data.token));
          }
        }
        return response.data;
      }).catch(function (error) {
        // alert(error.response.data.errors);
      });
  }

  mobileEmail(email: string){
    return axios.post(API_URL + "login/mobile_email", {
      email
    }).then(response => {
      alert('Email sent');
    }).catch(function (error) {
      //console.log(error.response.data.error);
      alert(error.response.data.errors);
    });
  }

  logout() {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    //console.log("logged out");
  }

  register(firstName: string, lastName: string, email: string, password: string,option: number) {
    return axios.post(API_URL + "signup", {
      firstName,
      lastName,
      email,
      password
    })
    .then(response => {
      if (response.data.token) {
        if (option === 1) {
          localStorage.setItem("token", JSON.stringify(response.data.token));
        } else if (option === 0) {
          sessionStorage.setItem("token", JSON.stringify(response.data.token));
        } else {
          sessionStorage.setItem("token", JSON.stringify(response.data.token));
        }
      }
      return response.data;

    }).catch((error) =>{
      throw error
    });
  }

  getCurrentUser() {
    var userStr = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (userStr){
      return jwt_decode(userStr);
    }
    return null;
  }

  forgotPassword(email: string){
    return axios.post(API_URL + "resetPasswordEmail", {
      email
    });
  }

  resetPassword(email: string, hash: string, password: string){
    return axios.post(API_URL + "resetPassword", {
      email,
      encID: hash,
      newPassword: password
    })
  }

  changeEmail(email: string, hash: string) {
    return axios.post(API_URL + "user/change_email_action", {
      email,
      changeEmailToken: hash
    })
  }
}

export default new AuthService();
